<template>
  <div
    :style="{ display: displayOverlay ? 'block' : 'none' }"
    style="z-index: 9999; position: fixed; top: 0; right: 0; left: 0; bottom: 0; background-color: black; opacity: .4"
  >
    <div class="text-center loader-big">
      <br><FontAwesomeIcon icon="spinner" spin />
    </div>
  </div>
</template>

<script>
export default {

  name: 'OverlayLoader',

  props: {
    displayOverlay: Boolean
  }

}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/shared/OverlayLoader.vue